<template>

  <!--footer-->
  <div class="footer_dk">
    <div class="bigTailBox">
      <div class="theLowerRightCornerToReturnTo" v-show="backTopFlag" @click="backTop()">
        <img src="../assets/image/returntop.png" alt="">
      </div>

      <div class="footer">
        <div class="footer_left">
          <div class="footer_dh">
            地址:辽宁省沈阳市沈北新区建设南一路5号 邮编:110122
          </div>
          <div class="footer_dh">
            办公室电话:024-89708710 招生电话:89708729 就业电话:89708730
          </div>
          <div class="footer_dh">
            站点建设与维护:信息技术中心
          </div>
          <div class="footer_dh">
            版权所有:辽宁省交通高等专科学校 辽ICP备 15018630号
          </div>
        </div>
        <div class="footer_right">
          <div class="footer_code">
            <img src="../assets/image/jiaozhuan_17.jpg" alt="">
            <p>扫码进入微博</p>
          </div>
          <div class="footer_code">
            <img src="../assets/image/jiaozhuan_19.jpg" alt="">
            <p>扫码关注官方微信</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--footer End-->

</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
export default {
  name: 'footerbottom',
  props: {
    msg: String
  },
  setup() {
    const backTopFlag = ref(false)//用来判断样式
    const backTop = () => {
      let top = document.documentElement.scrollTop//获取点击时页面的滚动条纵坐标位置
      const timeTop = setInterval(() => {
        document.documentElement.scrollTop = top -= 50//一次减50往上滑动
        if (top <=0) {
          clearInterval(timeTop)
        }
      }, 5)//定时调用函数使其更顺滑
    }

    const handleScroll = () => {
      if (document.documentElement.scrollTop > 450) {
        backTopFlag.value = true
      } else {
        backTopFlag.value = false
      }
      //往下滑超过20则显示 否则则不显示按钮
    }

    onMounted(() => {
      window.addEventListener('scroll', handleScroll)
    })//监听滚动事件
    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })//离开页面时移除监听事件
    return {
      backTop,
      handleScroll,
      backTopFlag,
    };

  }
}
</script>

<style scoped>

</style>